import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Heart, Loader2 } from "lucide-react";
import { API } from "../lib/api";
import { Stars } from "../components/Stars";

export default function ReviewPage() {
  const { token } = useParams();
  const [state, setState] = useState("loading");
  const [name, setName] = useState("");
  const [text, setText] = useState("");
  const [rating, setRating] = useState(0);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    axios.get(`${API}/reviews/${token}`)
      .then(({ data }) => { setName(data.name.split(" ")[0] || ""); setState(data.submitted ? "done" : "form"); })
      .catch(() => setState("invalid"));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (!rating) return toast.error("Please choose a star rating.");
    setSending(true);
    try {
      await axios.post(`${API}/reviews/${token}`, { rating, display_name: name.trim(), text: text.trim() });
      setState("done");
    } catch (err) {
      toast.error(err?.response?.data?.detail?.toString() || "Could not send. Please try again.");
    }
    setSending(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-16">
      <div className="card-surface p-8 md:p-10 max-w-xl w-full" data-testid="review-page">
        {state === "loading" && <Loader2 className="mx-auto text-teal-400 animate-spin" size={32} />}
        {state === "invalid" && <p className="text-center text-neutral-400" data-testid="review-invalid">This link isn't valid anymore.</p>}
        {state === "done" && (
          <div className="text-center" data-testid="review-done">
            <Heart className="mx-auto text-amber-300 mb-4" size={36} />
            <h1 className="font-display text-3xl mb-2">Thank you.</h1>
            <p className="text-sm text-neutral-400">Your words might be exactly what someone else needs to read today.</p>
          </div>
        )}
        {state === "form" && (
          <form onSubmit={submit} className="space-y-4">
            <div className="text-xs uppercase tracking-[0.28em] text-amber-300/80">Share your experience</div>
            <h1 className="font-display text-3xl text-neutral-100">How was our call?</h1>
            <p className="text-sm text-neutral-400">A sentence or two is plenty. With your OK, it may appear on the Why We Recover site.</p>
            <div className="flex items-center gap-3">
              <Stars value={rating} onChange={setRating} size={26} testid="review-stars" />
              {rating > 0 && <span className="text-xs text-neutral-400">{rating}/5</span>}
            </div>
            <textarea required minLength={10} maxLength={1200} rows={5} value={text} onChange={(e) => setText(e.target.value)}
              aria-label="Your experience" placeholder="What did the session mean to you?" data-testid="review-text" className="wwr-input w-full rounded-xl px-4 py-3 text-sm" />
            <input required maxLength={60} value={name} onChange={(e) => setName(e.target.value)}
              aria-label="Name to show" placeholder="Name to show (first name or initials)" data-testid="review-name" className="wwr-input w-full rounded-xl px-4 py-3 text-sm" />
            <button type="submit" disabled={sending} data-testid="review-submit" className="btn-primary w-full py-3 text-sm disabled:opacity-60">
              {sending ? "Sending…" : "Share it"}
            </button>
          </form>
        )}
        <Link to="/" className="block text-center mt-8 text-sm text-teal-300 hover:text-teal-200" data-testid="review-home">Back to Why We Recover</Link>
      </div>
    </div>
  );
}
